<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка суши и роллов</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Японские блюда уже давно завоевали популярность у жителей г. {{city.name}}.</p>
            <p>На протяжении многих лет японская кухня занимает лидирующие позиции среди заказываемых блюд и уступает только пицце. Это вкусная, питательная, натуральная и полезная еда!</p>
            <p>Устройте себе настоящий японский обед или ужин. Не хотите идти в ресторан – просто заказывайте суши и роллы не выходя из дома или офиса.</p>
            <p>На сайте <router-link to="/">хочу-поесть.рф</router-link> заказать суши и роллы в г. {{city.name}} Вы можете круглосуточно.</p>
            <p>Наши рестораны избавляют от всех забот - Вам привезут роллы, суши, имбирь и соевый соус, а также бамбуковые палочки.</p>
            <center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/sushi1.jpg" alt="Заказ суши и роллов" width="700" /></center>
            <h2 style="margin-top:2%;">Получайте удовольствие от изысканных японских блюд!</h2>
            <p>Вы сами выбираете ресторан и количество заказываемых блюд: по стоимости, весу и предпочтениям начинок. Больше Вам не нужно искать в интернете и просматривать десятки сайтов – все теперь на <router-link to="/">хочу-поесть.рф</router-link>.</p>
            <p>Кстати, роллы можно приготовить в домашних условиях и для этого необходимо иметь всего лишь нехитрый набор, который можно приобрести в любом супермаркете. Наши рестораны делятся с Вами своими секретами и рецептами – посмотрите рецепты приготовления роллов и у Вас получится такое же вкусное блюдо, как готовят настоящие повара.</p>
            <router-link :to="'/product/1'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'sushi',
  props: ['city']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/sushi.vue